import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_INSURANCE_POLICY
interface InsurancePolicy {
    policy_number: string;
    policy_type: string;
    policy_icon: string;
    product_document: string | null;
    start_date: string;
    end_date: string;
    issue_date: string;
    status: string;
    insured_person_name: string;
    insured_person_type: string;
    insured_person_pin_or_tin: string;
    insurance_amount: string;
    insurance_subject: string;
    premium: string;
    currency: string;
    has_printout: boolean;
}

// INTERFACE_SUCCESS_RESPONSE
interface InsurancePolicySuccessResponse {
    data: InsurancePolicy[];
    message?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface InsurancePolicyErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface InsurancePolicyResult {
    data: InsurancePolicySuccessResponse | InsurancePolicyErrorResponse | GenericErrorResponse;
    status: number;
}

// GET INSURANCE POLICIES API
export const GetInsurancePolicies = async (
    language: 'az' | 'en' = 'az'
): Promise<InsurancePolicyResult> => {
    try {
        const response = await axiosInstance.get<InsurancePolicySuccessResponse>(
            '/core/insurance-policies'
        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};

